import e from "./ghl-ui.es695.js";
var t = typeof self == "object" && self && self.Object === Object && self, o = e || t || Function("return this")();
const f = o;
export {
  f as default
};
